import { useNavigate } from "react-router-dom";

const Openings = ({ data }) => {
  const navigate = useNavigate();

  const handleGo = (url) => {
    navigate(`/company/career/${url}`);
  };
  return (
    <div className="2xl:container px-20 px-6 w-full">
      <h2 className="text-24 sm:text-32 md:text-48 text-primarycolor font-semibold text-center">
        Opening positions / Current vacancy
      </h2>
      <div className="grid md:grid-cols-2 gap-6 grid-cols-1 py-10 md:py-20">  
        {data.openings.map((item, i) => (
          <div
            key={i}
            className=" p-6 md:p-8 flex flex-col gap-y-6 md:gap-y-10 items-start border-[1px] rounded-[24px] border-journyborder shadow-services"
          >
            <div className="flex gap-4  lg:gap-6 lg:items-center md:items-start">
              <img
                className="lg:w-[56px] lg:h-[56px] h-[40px] w-[40px] "
                src={process.env.PUBLIC_URL + "/images/Career/openings.svg"}
                alt="icon"
              />
              <div className="flex flex-col gap-4">
                <h4 className="text-primarycolor text-20 md:text-24 font-medium">
                  {item.title}
                </h4>
                <p className="text-secondaryblack text-14 sm:text-16 font-regular">
                  {item.para}
                </p>
              </div>
            </div>
            <div className="flex items-left gap-4">
              <p className="text-16 text-secodaryblack font-medium p-3 bg-gray rounded-[12px]">
                {item.year}
              </p>
              <p className="text-16 text-secodaryblack font-medium p-3 bg-gray rounded-[12px]">
                {item.time}
              </p>
            </div>
            <button
              onClick={() => handleGo(item.url)}
              className="border-ctaorange hover:bg-btnhover hover:text-white border-[1px] bg-white text-16 text-ctaorange py-3 px-5 rounded-[12px] font-semibold"
            >
              Apply Now
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Openings;
